namespace TabAurous.HR {
    export interface PayrollPeriodRow {
        PayrollPeriodId?: number;
        PayrollPeriodCode?: string;
        FromDate?: string;
        ToDate?: string;
    }

    export namespace PayrollPeriodRow {
        export const idProperty = 'PayrollPeriodId';
        export const nameProperty = 'PayrollPeriodCode';
        export const localTextPrefix = 'HR.PayrollPeriod';
        export const deletePermission = 'HR:PayrollPeriod:Delete';
        export const insertPermission = 'HR:PayrollPeriod:Add';
        export const readPermission = '*';
        export const updatePermission = 'HR:PayrollPeriod:Edit';

        export declare const enum Fields {
            PayrollPeriodId = "PayrollPeriodId",
            PayrollPeriodCode = "PayrollPeriodCode",
            FromDate = "FromDate",
            ToDate = "ToDate"
        }
    }
}
